import $ from 'jquery'
import Component from  "../models/Component"

export default class GMap extends Component {
  static _initializers = []

  constructor (element, context) {
    super(element, context)

    

    this.mapStyle = [

    {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": 33
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f7f7f7"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#deecdb"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": "25"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "lightness": "25"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
            {
                "saturation": "-90"
            },
            {
                "lightness": "25"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#e0f1f9"
            }
        ]
    }

	]

    // Add the initialization of this GMap instance to the list of all
    // gMaps to be initialized
    GMap._initializers.push(() => {
      this.initGoogleMaps()
    })

    $(() => {
      this.lat = parseFloat(this.getData('lat'));
      this.lng = parseFloat(this.getData('lng'));
      this.zoom = parseFloat(this.getData('zoom'), 14);
      this.loadGoogleMaps()
    })
  }

  // This script will be executed after the googleapis js is loaded
  initGoogleMaps () {
    this.center = new google.maps.LatLng(this.lat, this.lng)
    this.map = new google.maps.Map(this.element.get(0), {
      zoom: this.zoom,
      minZoom: 4,
      center: this.center,
      scrollwheel: false,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      rotateControl: false,
      styles: this.mapStyle,
    })

    //this.pinMaps = window.location.origin+'/wp-content/uploads/2023/04/pin.png'

    // this.marker = new google.maps.Marker({
    //   position: this.center,
    //   map: this.map,
    //   icon: this.pinMaps,
      
    // })
    // this.marker.addListener("click", () => {
    //   this.onMarkerClick();
    // })
    this.element.parent().removeClass('loading')
  }

  onMarkerClick() {
    //window.open(this.url, '_blank');
  }

  loadGoogleMaps () {
    // Append google apis script if not already present
    if (!window.initGoogleMaps) {
      window.initGoogleMaps = () => {
        GMap.initAllGoogleMaps()
      }
      var scriptSrc = 'https://maps.googleapis.com/maps/api/js?key=' + window._gTheme_.google_maps_api_key + '&callback=initGoogleMaps'
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = scriptSrc
      document.body.appendChild(script)
    }
  }

  static initAllGoogleMaps () {
    GMap._initializers.forEach(function (initializer) {
      initializer()
    })
  }
}
